export enum BaseCustomerEmployeeContractSignStatusesEnum {
  'SIGNATURE_REQUIRED' = 'customer',
  'WAITING_FOR_PARTNER' = 'psp',
  'SIGNED' = 'signed',
}
